<template>
    <Page :header="(!isPWA && !isTgApp) ? 'AML' : ''" type="white">
        <template v-slot:body>
            <Aml />
        </template>
    </Page>
</template>

<script>
import Page     from '@/components/sides/Page.vue' 
import Aml    from '@/components/public/Aml.vue' 
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            header: {
                en:{
                    title: "AML Policy",
                },
                ru:{
                    title: "Политика по противодействию отмыванию денежных средств (AML)",
                }
            },
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
    },
    components: {
        Page,
        Aml
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
    },
    mounted() {
        try {
            this.SetHeaderTitle(this.header[this.lang].title)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                class: 'text-xs opacity-0',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    }
}
</script>